let currentSlide = 0;
const slides = document.querySelectorAll(".tick");

function nextSlide() {
    slides[currentSlide].className = 'tick';
    currentSlide = (currentSlide + 1) % slides.length;
    slides[currentSlide].className = 'tick showing';
}

// Change slide every 3 seconds
setInterval(nextSlide, 3000);

function updatePhoneStatus() {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0 is Sunday, 1 is Monday, etc.
  const currentTime = now.getHours() + now.getMinutes() / 60; // Convert current time to decimal hours
  const openingTime = 9.00; // 9:00 AM converted to decimal
  const closingTime = 17.00; // 5:00 PM converted to decimal

  let message;

  // Check if it's a weekday and within working hours
  if (dayOfWeek >= 1 && dayOfWeek <= 5 && currentTime >= openingTime && currentTime <= closingTime) {
    message = '<div class="phone-status open">✔ Our lines are currently open</div>';
  } else {
    let hoursUntilOpen;

    if (dayOfWeek >= 1 && dayOfWeek <= 5 && currentTime < openingTime) {
      hoursUntilOpen = Math.floor(openingTime - currentTime);
    } else {
      // Calculate the opening time of the next weekday
      let nextOpen = new Date(now);
      nextOpen.setDate(now.getDate() + ((dayOfWeek === 0 || dayOfWeek === 5 || dayOfWeek === 6) ? 8 - dayOfWeek : 1));
      nextOpen.setHours(9, 0, 0, 0); // Next opening time is 9:00 AM

      const diffMs = nextOpen - now;
      hoursUntilOpen = Math.floor(diffMs / 1000 / 60 / 60);
    }

    if (hoursUntilOpen > 2) {
      // Determine if opening is today or tomorrow
      let openingDayMessage = "today";
      if (currentTime > closingTime || dayOfWeek === 6 || dayOfWeek === 0 || (dayOfWeek === 5 && currentTime > closingTime)) {
        openingDayMessage = "tomorrow";
      }
      message = `<div class="phone-status closed">Lines open ${openingDayMessage} at 9 AM</div>`;
    } else {
      let minsUntilOpen = Math.round((hoursUntilOpen * 60) % 60);
      let timeLeftMessage = hoursUntilOpen > 0
        ? `${hoursUntilOpen} hours & ${minsUntilOpen} mins`
        : `${minsUntilOpen} mins`;

      message = `<div class="phone-status closed">Lines open in ${timeLeftMessage}</div>`;
    }
  }

  // Update the innerHTML of the div with ID 'phone-msg'
  const phoneMsgDiv = document.getElementById('phone-msg');
  if (phoneMsgDiv) {
    phoneMsgDiv.innerHTML = message;
  }
}

// Update status immediately and every minute thereafter
updatePhoneStatus();
setInterval(updatePhoneStatus, 60000); // 60000 milliseconds = 1 minute

        function updateBusinessStatus() {
            // Get the current date and time
            const now = new Date();
            const dayOfWeek = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
            const hours = now.getHours(); // Get the current hour (0-23)

            // Check if it's Monday-Friday and between 9 AM and 5 PM
            if (dayOfWeek >= 1 && dayOfWeek <= 5 && hours >= 9 && hours < 17) {
                // We're within business hours, update the text
                const elements = document.querySelectorAll('.number-text .addon-title');
                elements.forEach(element => {
                    element.innerHTML = "We're Open";
                  element.style.color = "#00B67A";
                });
            }
            // If it's outside business hours, the default text "Order on" remains unchanged
        }

        // Run the function when the script loads
        updateBusinessStatus();
        setInterval(updateBusinessStatus, 60000);